import { PageLayout } from "../shared/layouts/PageLayout";
import { dashboardBreadcrumbs } from "../features/Dashboard/dashboard-breadcrumbs";
import { Settings } from "@features/Settings";

const breadcrumbs = {
  current: dashboardBreadcrumbs.settings,
  previous: [dashboardBreadcrumbs.accountSettings],
};

export function SettingsPage() {
  return (
    <PageLayout breadcrumbs={breadcrumbs}>
      <Settings />
    </PageLayout>
  );
}
